import View from '~/app/View'

import ArticleTwoColumn from '~/components/article/article-two-column'
import ArticleTwoColumnGallery from '~/components/article/article-two-column-gallery'

import ArticleMediaTwoColumn from '~/components/article/article-media-two-column'
import ArticleMediaOneColumnGallery from '~/components/article/article-media-one-column-gallery'

import ArticleCardCarousel from '~/components/article/article-card-carousel'

import ProductSliderHomepage from '~/components/homepage/product-slider-homepage'

import NewsletterSignup from '~/components/newsletter/newsletter-signup'
import NewsletterSuccessPopup from '~/components/newsletter/newsletter-success-popup'

import '@/templates/article.scss'

const pageView = new View()
pageView.init({
  ArticleTwoColumn,
  ArticleTwoColumnGallery,
  ArticleMediaTwoColumn,
  ArticleMediaOneColumnGallery,
  ArticleCardCarousel,
  ProductSliderHomepage,
  NewsletterSignup,
  NewsletterSuccessPopup,
})
